import React from 'react';

import { Box } from '@betterment/samba-react';
import { Helmet } from 'react-helmet';

import { Notifications } from '../../notifications/Notifications';
import { WithLayout } from '../../RetailApp/components/WithLayout';
import Footer from '../components-v2/footer/Footer';

interface LayoutProps {
  feature: string;
  pageTitle: string | null;
}

const Layout: React.FC<React.PropsWithChildren<LayoutProps>> = ({ children, feature, pageTitle }) => (
  <WithLayout parts={{ sidebar: true, footer: false }} feature={feature}>
    <Box
      css={{
        bg: 'background',
        display: 'grid',
        gridTemplateColumns: '1fr minmax(min-content, 1200px) 1fr',
        gridTemplateAreas: `
          "notifications notifications notifications"
          "header header header"
          ". content ."
          ". footer ."
        `,
        gridColumnGap: {
          base: 'space.0',
          md: 'space.400',
        },
      }}
    >
      <Helmet titleTemplate="%s | Betterment" defaultTitle="Betterment">
        <title>{pageTitle}</title>
      </Helmet>
      <Notifications css={{ paddingTop: 'space.400', gridArea: 'notifications' }} />
      {children}
      <Box
        css={{
          gridArea: 'footer',
          maxWidth: '1200px',
          paddingX: {
            sm: 'space.400',
            md: 'space.0',
          },
        }}
      >
        <Footer />
      </Box>
    </Box>
  </WithLayout>
);

const Header: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Box
    css={{
      bg: 'background.surface',
      gridArea: 'header',
      display: 'grid',
      gridTemplateColumns: 'subgrid',
      marginBottom: {
        base: 'space.200',
        md: 'space.400',
      },
    }}
  >
    <Box
      css={{
        gridColumn: 2,
      }}
    >
      {children}
    </Box>
  </Box>
);

const Content: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Box
    css={{
      bg: 'background',
      gridArea: 'content',
    }}
  >
    {children}
  </Box>
);

type ApplicationLayoutComposite = typeof Layout & {
  Header: typeof Header;
  Content: typeof Content;
};
export const ApplicationLayout = Layout as ApplicationLayoutComposite;
ApplicationLayout.Header = Header;
ApplicationLayout.Content = Content;
